import React, {useState} from 'react';
import axios from 'axios'
import { useSignIn, useIsAuthenticated } from 'react-auth-kit';
import { useNavigate } from 'react-router-dom';

const titleStyle = {
    display:"flex",
    padding: 16,
    textAlign:"center",
    contentAlign:"center",
    justifyContent:"center",
    background: 'rgba(199, 137, 236, 0.8)',
    color: '#fff',
    
};
const mainStyle = {
    padding: 16,
    textAlign:"center",
    contentAlign:"center",
    justifyContent:"center",
    font: "20px",
    background: 'rgba(199, 137, 236, 0.8)',
    color: '#fff',
    
};

const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const signIn = useSignIn();
    const isAuthenticated = useIsAuthenticated();
    const navigate = useNavigate();

    const handleLogin = async () =>{
        try{
            const response = await axios.post("/login",{
                username,
                password,
            });
            signIn({
                token: response.data.token,
                expiresIn: response.data.lifetime,
                tokenType: "Bearer",
                authState: {username},
            })
            if(isAuthenticated){
                console.log('success')
                navigate('/authgrid')
            }else{
                console.log("failed")
            }
        }catch(err){
            console.log(err)
        }
  
    };
    
    return(
        <div>
            <div style={titleStyle}>
                <h1>Login</h1>
            </div><br/><br/>
            <div style={mainStyle}>
                <label htmlFor='username'>Username:</label><br/>
                <input type="text" placeholder='Username' value={username} onChange={(e) => setUsername(e.target.value)}/><br/><br/>
                <label htmlFor="password">Password:</label><br/>
                <input type="password" placeholder='Password' value={password} onChange={(e) => setPassword(e.target.value)} /><br/><br/>
                <button onClick={handleLogin}>Login</button>
            </div>
        </div>
    )

}

export default Login;
